// Viewer 照片数据类型
export interface ViewerPhoto {
  largeURL: string
  smallURL: string
  videoURL: string
  mediaType: number
  seq: string
  saveName: string
  sourceType: number
}

// 媒体类型
type MediaType = 'video' | 'image'

/**
 * 判断传入的 URL 是 视频 or 图片
 * @param {string} url - 媒体URL
 * @returns {string} - 'video' 或 'image'
 */
export const judgeUrlMediaType = (url: string): MediaType => {
  if (!url) return 'image'
  let temp = url.split('?')[0].split('.')
  return ['mp4', 'webm', 'ogv', 'mov', 'avi', 'flv'].includes(
    temp[temp.length - 1]
  )
    ? 'video'
    : 'image'
}

/**
 * 获取视频缩略图URL
 * @param {string} videoUrl - 视频URL
 * @returns {string} - 缩略图URL
 */
export const getVideoThumbnail = (videoUrl: string): string => {
  // 如果是视频，添加截图参数
  if (judgeUrlMediaType(videoUrl) !== 'image') {
    return (
      videoUrl.split('?')[0] +
      '?x-oss-process=video/snapshot,t_0,f_jpg,ar_auto,w_200'
    )
  }
  return videoUrl
}

/**
 * 格式化照片数据为Viewer组件需要的格式
 * @param {Array} photos - 照片数组
 * @returns {Array} - 格式化后的照片数据
 */
export const formatPhotosForViewer = (photos: string[]): ViewerPhoto[] => {
  return photos.map((photo, idx) => {
    // 手动判断媒体类型
    const isVideo = judgeUrlMediaType(photo) === 'video'
    const mediaType = isVideo ? 1 : 0 // 0表示图片，1表示视频

    // 获取文件扩展名
    const extension = photo.split('?')[0].split('.').pop()

    // 如果是视频，使用视频截图作为缩略图
    const thumbnailUrl = isVideo ? getVideoThumbnail(photo) : photo

    return {
      largeURL: !isVideo ? photo : '', // 如果是图片，设置largeURL
      smallURL: thumbnailUrl, // 缩略图URL，视频使用截图
      videoURL: isVideo ? photo : '', // 如果是视频，设置videoURL
      mediaType: mediaType,
      seq: `photo-${idx}`, // 唯一标识
      saveName: `photo-${idx}.${extension}`, // 保存时的文件名带扩展名
      sourceType: 0
    }
  })
}
